import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lib-tracking-table-empty-state',
  imports: [],
  templateUrl: './tracking-table-empty-state.component.html',
  styleUrl: './tracking-table-empty-state.component.scss',
})
export class TrackingTableEmptyStateComponent
  implements INoRowsOverlayAngularComp
{
  agInit(): void {
    // this is necessary
  }
}
